@for (measure of measures; track measure.label) {
	<div class="content">
		<span class="header"> {{ measure.label }}</span>
		<span class="detail"> {{ measure.value }} </span>
	</div>
}
